import { mapActions, mapGetters } from "vuex";

export const safirMixin = {
  computed: {
    ...mapGetters({
      safirIsLoading: "safir/createFacture/isLoading",
      safir: "safir/createFacture/retrieved",
      safirError: "safir/createFacture/error",
    }),
  },
  methods: {
    ...mapActions({
      createFacture: "safir/createFacture/createFacture",
      resetFacture: "safir/createFacture/reset",
    }),
  },
};
